import script from "./AreaComercial.vue?vue&type=script&setup=true&lang=js"
export * from "./AreaComercial.vue?vue&type=script&setup=true&lang=js"

import "./AreaComercial.vue?vue&type=style&index=0&id=76daf6b9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76daf6b9"]])

export default __exports__